import React from 'react';
import Animator from './Animator';

export default class TransitionManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      childPosition: Animator.CENTER,
      curChild: props.children,
      curUniqId: props.uniqId,
      prevChild: null,
      prevUniqId: null,
      animationCallback: null,
    };
    this.currentTransitionType = null;
  }

  componentDidUpdate(prevProps) {
    const prevUniqId = prevProps.uniqKey || prevProps.children.type;
    const uniqId = this.props.uniqKey || this.props.children.type;
    if (prevUniqId !== uniqId) {
      // this.currentTransitionType = null;
      // if (uniqId.indexOf(TransitionManager.URL_RESULT_TOP) >= 0) {
      //   if (
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_HAIR_CARE) >= 0 ||
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_SCALP_CARE) >= 0 ||
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_CONFIRM) >= 0
      //   ) {
      //     this.currentTransitionType = Animator.TO_RIGHT;
      //   } else {
      //     this.currentTransitionType = Animator.TO_FADE;
      //   }
      // } else if (uniqId.indexOf(TransitionManager.URL_RESULT_HAIR_CARE) >= 0) {
      //   if (prevUniqId.indexOf(TransitionManager.URL_RESULT_TOP) >= 0) {
      //     this.currentTransitionType = Animator.TO_LEFT;
      //   } else if (
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_SCALP_CARE) >= 0 ||
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_CONFIRM) >= 0
      //   ) {
      //     this.currentTransitionType = Animator.TO_RIGHT;
      //   } else {
      //     this.currentTransitionType = Animator.TO_FADE;
      //   }
      // } else if (uniqId.indexOf(TransitionManager.URL_RESULT_SCALP_CARE) >= 0) {
      //   if (
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_TOP) >= 0 ||
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_HAIR_CARE) >= 0
      //   ) {
      //     this.currentTransitionType = Animator.TO_LEFT;
      //   } else if (prevUniqId.indexOf(TransitionManager.URL_RESULT_CONFIRM) >= 0) {
      //     this.currentTransitionType = Animator.TO_RIGHT;
      //   } else {
      //     this.currentTransitionType = Animator.TO_FADE;
      //   }
      // } else if (uniqId.indexOf(TransitionManager.URL_RESULT_CONFIRM) >= 0) {
      //   if (
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_TOP) >= 0 ||
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_HAIR_CARE) >= 0 ||
      //     prevUniqId.indexOf(TransitionManager.URL_RESULT_SCALP_CARE) >= 0
      //   ) {
      //     this.currentTransitionType = Animator.TO_LEFT;
      //   } else {
      //     this.currentTransitionType = Animator.TO_FADE;
      //   }
      // } else {
      //   this.currentTransitionType = Animator.TO_FADE;
      // }
      this.currentTransitionType = Animator.TO_FADE;
    }
    if (prevUniqId !== uniqId) {
      this.setState({
        childPosition: this.currentTransitionType,
        curChild: this.props.children,
        curUniqId: uniqId,
        prevChild: prevProps.children,
        prevUniqId,
        animationCallback: this.swapChildren,
      });
    }
  }

  swapChildren = () => {
    let transitionType = Animator.FROM_FADE;
    if (this.currentTransitionType === Animator.TO_LEFT) {
      transitionType = Animator.FROM_RIGHT;
    } else if (this.currentTransitionType === Animator.TO_RIGHT) {
      transitionType = Animator.FROM_LEFT;
    }
    this.setState({
      childPosition: transitionType,
      prevChild: null,
      prevUniqId: null,
      animationCallback: null,
    });
  };

  render() {
    return (
      <Animator position={this.state.childPosition} animationCallback={this.state.animationCallback}>
        {this.state.prevChild || this.state.curChild}
      </Animator>
    );
  }
}
TransitionManager.URL_RESULT_TOP = '/salon-consultation/sublimic/diagnosis/result/top';
TransitionManager.URL_RESULT_HAIR_CARE = '/salon-consultation/sublimic/diagnosis/result/hair-care';
TransitionManager.URL_RESULT_SCALP_CARE = '/salon-consultation/sublimic/diagnosis/result/scalp-care';
TransitionManager.URL_RESULT_CONFIRM = '/salon-consultation/sublimic/diagnosis/result/confirm';



// WEBPACK FOOTER //
// ./src/components/RouterAnimation/TransitionManager.js